"use strict";

module.exports = function (rowId) {
  return this.openChildRows.includes(rowId) ? 'VueTables__child-row-toggler--open' : 'VueTables__child-row-toggler--closed';
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/child-row-toggler-class.js
// module id = 1584
// module chunks = 64